import { createContext } from 'react';

/**
 * Per-locale path overrides for the language menu, for pages whose URL slug differs per locale
 * (e.g. `/nl/gastheer-worden` vs `/de/gastgeber-werden`). Without a value the menu just swaps
 * the leading locale segment of the current path.
 *
 * Value: `{ [locale: string]: string } | null` — paths without origin, e.g. `/de/gastgeber-werden`.
 */
const LocalizedPathsContext = createContext(null);

export default LocalizedPathsContext;
